import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../../lib/utils";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  tone?: "default" | "primary" | "urgent";
}

export function Badge({ children, className, tone = "default", ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium tracking-wide",
        tone === "default" && "border-ink/10 bg-ink/5 text-muted",
        tone === "primary" && "border-primary/30 bg-primary/10 text-primary",
        tone === "urgent" && "border-urgent/40 bg-urgent/10 text-urgent",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
